module.exports = __webpack_public_path__ + "img/html-evolution-13.8034fed6.jpg";